var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-radio",on:{"click":function($event){$event.preventDefault();_vm.onClick($event)}}},[_c('label',[_c('div',{staticClass:"form-radio__label"},[_vm._v("$"+_vm._s(_vm.value))]),_vm._v(" "),_c('input',{ref:"radio",attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checked}}),_vm._v(" "),_c('span')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523605fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseRadio.vue
// module id = null
// module chunks = 